// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"deckCardContextMenu_contextMenu__sUl1z","externalLinks":"deckCardContextMenu_externalLinks__TCLfV","categoryMenu":"deckCardContextMenu_categoryMenu__kH0ht"};